var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Oom',{attrs:{"config":_vm.config,"tm_params":_vm.tm_params,"data":_vm.data,"id":_vm.id}})
}
var staticRenderFns = []

export { render, staticRenderFns }